<template>
  <v-container>
    <v-row justify="center">
      <v-col cols="12">
        <v-card color="primary" class="card">
          <v-card-title>Asignación de items a personal</v-card-title>
          <v-card-text>
            <v-container>
              <v-row align="center">
                <v-col>
                  <v-menu
                    v-model="menuFechaSolicitud"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        :value="fechaSolicitud"
                        append-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        rounded
                        filled
                        dense
                        color="secondary"
                        background-color="primary"
                      >
                        <template v-slot:label>Fecha de solicitud <span class="red--text">*</span> </template>
                      </v-text-field>
                    </template>
                    <v-date-picker
                      v-model="asignacionEquipamiento.fechaSolicitud"
                      @input="menuFechaSolicitud = false"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col>
                  <v-menu
                    v-model="menuFechaAsignacion"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        :value="fechaAsignacion"
                        append-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        rounded
                        filled
                        dense
                        color="secondary"
                        background-color="primary"
                      >
                        <template v-slot:label>Fecha de asignación <span class="red--text">*</span> </template>
                      </v-text-field>
                    </template>
                    <v-date-picker
                      v-model="asignacionEquipamiento.fechaAsignacion"
                      @input="menuFechaAsignacion = false"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col>
                  <v-text-field
                    label="Número de folio de resguardo"
                    v-model="asignacionEquipamiento.folioResguardo"
                    rounded
                    filled
                    dense
                    color="secondary"
                    background-color="primary"
                  ></v-text-field>
                </v-col>
                <v-col>
                  <v-file-input
                    label="Evidencia"
                    v-model="asignacionEquipamiento.file"
                    rounded
                    filled
                    dense
                    color="secondary"
                    background-color="primary"
                  ></v-file-input>
                </v-col>
                <v-col cols="12">
                  <v-row>
                    <v-col cols="6">
                      <v-autocomplete
                        v-model="selectedEquipo"
                        label="Items"
                        :items="filteredEquipos"
                        item-text="CatItem.item"
                        background-color="primary"
                        color="secondary"
                        rounded
                        filled
                        dense
                        :clearable="false"
                        multiple
                        hide-selected
                        return-object
                      >
                        <template v-slot:item="{ item }">
                          <v-list-item-content>
                            <v-list-item-title class="font-weight-bold">
                              {{ item.CatItem.item }}
                            </v-list-item-title>
                            <v-list-item-subtitle>
                              {{ item.numero }}
                            </v-list-item-subtitle>
                            <v-list-item-subtitle> Vigencia: {{ item.aniosVigencia }} </v-list-item-subtitle>
                          </v-list-item-content>
                        </template>
                      </v-autocomplete>
                    </v-col>
                    <v-col cols="6">
                      <v-textarea
                        label="Observaciones"
                        v-model="asignacionEquipamiento.observaciones"
                        rounded
                        filled
                        dense
                        color="secondary"
                        background-color="primary"
                        no-resize
                        rows="4"
                      ></v-textarea>
                    </v-col>
                  </v-row>
                </v-col>

                <v-col cols="12">
                  <v-data-table
                    :headers="headers"
                    :items="selectedEquipo"
                    class="transparent"
                    hide-default-footer
                    disable-pagination
                  >
                  </v-data-table>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions class="justify-center">
            <v-btn color="secondary" @click="triggerSaveAsignacion()" :loading="loading" :disabled="loading">
              Registrar asignación de items
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import moment from 'moment'
import { mapGetters, mapActions } from 'vuex'

export default {
  props: {
    id: {
      type: Number,
    },
  },

  data() {
    return {
      loading: false,
      menuFechaSolicitud: false,
      menuFechaAsignacion: false,
      menuFechaFabricacion: [],
      menuAniosVigencia: [],
      selectedTipoItem: null,
      asignacionEquipamiento: {
        fk_idPersonal: null,
        fechaSolicitud: '',
        fechaAsignacion: '',
        observaciones: '',
        evidencia: '',
        folioResguardo: '',
        equipoAsignado: [],
        file: null,
      },
      headers: [
        { text: 'Item', value: 'CatItem.item' },
        { text: 'Número', value: 'numero' },
        { text: 'Fecha de fabricación', value: 'fechaFabricacion' },
        { text: 'Vigencia', value: 'aniosVigencia' },
      ],
      selectedEquipo: [],
    }
  },

  computed: {
    ...mapGetters('tipoItem', {
      tipoItem: 'getTiposItem',
    }),
    ...mapGetters('asignacionEquipo', {
      asignacionesEquipo: 'getAsignacionesEquipo',
    }),
    ...mapGetters('equipo', {
      equipos: 'getEquipos',
    }),
    filteredEquipos() {
      return this.equipos.filter((equipo) => equipo.fk_idCatEstatus == 2)
    },
    fechaSolicitud() {
      return this.asignacionEquipamiento.fechaSolicitud
        ? moment(this.asignacionEquipamiento.fechaSolicitud).format(this.API_DATE_FORMAT)
        : ''
    },
    fechaAsignacion() {
      return this.asignacionEquipamiento.fechaAsignacion
        ? moment(this.asignacionEquipamiento.fechaAsignacion).format(this.API_DATE_FORMAT)
        : ''
    },
  },

  methods: {
    ...mapActions('asignacionEquipo', ['saveAsignacionEquipo']),
    async triggerSaveAsignacion() {
      this.loading = true

      this.asignacionEquipamiento.equipoAsignado = []

      this.selectedEquipo.forEach((equipo) => {
        this.asignacionEquipamiento.equipoAsignado.push({
          fk_idEquipo: equipo.idEquipamiento,
          nombre: equipo.CatItem.item,
        })
      })

      await this.saveAsignacionEquipo({
        fk_idPersonal: this.id,
        fechaSolicitud: this.fechaSolicitud,
        fechaAsignacion: this.fechaAsignacion,
        observaciones: this.asignacionEquipamiento.observaciones,
        evidencia: this.asignacionEquipamiento.file ? this.asignacionEquipamiento.file.name : '',
        folioResguardo: this.asignacionEquipamiento.folioResguardo,
        equipoAsignado: this.asignacionEquipamiento.equipoAsignado,
        file: this.asignacionEquipamiento.file,
      })

      this.loading = false
      this.$router.push('/equipamiento/personal')
    },
  },
}
</script>

<style scoped>
/* Estilos modernos para Asignación de Equipamiento */
.card {
  background: rgba(46, 36, 22, 0.6) !important;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 159, 67, 0.2);
  border-radius: 20px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
  transition: all 0.3s ease;
  animation: fadeInUp 0.6s ease-out;
}

/* Títulos */
::v-deep .v-card-title {
  color: #e0e0e0 !important;
  font-weight: 700 !important;
  letter-spacing: 0.5px;
  padding: 24px !important;
}

/* Inputs modernos (text-field, select, textarea, autocomplete, file-input) */
::v-deep .v-text-field .v-input__slot,
::v-deep .v-select .v-input__slot,
::v-deep .v-textarea .v-input__slot,
::v-deep .v-autocomplete .v-input__slot,
::v-deep .v-file-input .v-input__slot {
  background: transparent !important;
  border: 1px solid rgba(255, 159, 67, 0.2) !important;
  border-radius: 12px !important;
  transition: all 0.3s ease !important;
}

/* Hover state */
::v-deep .v-text-field .v-input__slot:hover,
::v-deep .v-select .v-input__slot:hover,
::v-deep .v-textarea .v-input__slot:hover,
::v-deep .v-autocomplete .v-input__slot:hover,
::v-deep .v-file-input .v-input__slot:hover {
  border-color: rgba(255, 159, 67, 0.3) !important;
}

/* Focus state */
::v-deep .v-input--is-focused .v-input__slot {
  border-color: #ff9f43 !important;
  box-shadow: none !important;
  background: transparent !important;
}

/* Labels */
::v-deep .v-label {
  color: rgba(224, 224, 224, 0.7) !important;
  font-weight: 500;
}

::v-deep .v-input--is-focused .v-label,
::v-deep .v-label--active {
  color: #ffbe76 !important;
  font-weight: 600;
}

/* Input text */
::v-deep .v-text-field__slot input,
::v-deep .v-select__slot input,
::v-deep .v-textarea textarea {
  color: #e0e0e0 !important;
}

/* Iconos en inputs */
::v-deep .v-input__prepend-inner .v-icon,
::v-deep .v-input__append-inner .v-icon,
::v-deep .v-input__append-outer .v-icon {
  color: rgba(255, 159, 67, 0.6) !important;
}

::v-deep .v-input--is-focused .v-input__prepend-inner .v-icon,
::v-deep .v-input--is-focused .v-input__append-inner .v-icon,
::v-deep .v-input--is-focused .v-input__append-outer .v-icon {
  color: #ff9f43 !important;
}

/* Select items */
::v-deep .v-select__selections {
  color: #e0e0e0 !important;
}

/* Asterisco rojo */
.red--text {
  color: #ff5252 !important;
}

/* Menús dropdown */
::v-deep .v-menu__content {
  background: rgba(46, 36, 22, 0.95) !important;
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 159, 67, 0.3);
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.5);
}

::v-deep .v-list {
  background: transparent !important;
  padding: 8px;
}

::v-deep .v-list-item {
  border-radius: 8px;
  color: #e0e0e0 !important;
  transition: all 0.2s ease;
}

::v-deep .v-list-item:hover {
  background: rgba(255, 159, 67, 0.15) !important;
}

::v-deep .v-list-item--active {
  background: rgba(255, 159, 67, 0.2) !important;
}

::v-deep .v-list-item__title,
::v-deep .v-list-item__subtitle {
  color: inherit !important;
}

/* Date Picker */
::v-deep .v-date-picker-table {
  background: rgba(46, 36, 22, 0.6) !important;
}

::v-deep .v-date-picker-header {
  background: rgba(255, 159, 67, 0.1) !important;
}

::v-deep .v-date-picker-title {
  color: #e0e0e0 !important;
}

::v-deep .v-btn--active {
  background: linear-gradient(135deg, #ff9f43 0%, #ffbe76 100%) !important;
  color: #ffffff !important;
  box-shadow: 0 4px 12px rgba(255, 159, 67, 0.4);
}

::v-deep .v-date-picker-table__current {
  border: 2px solid #ff9f43 !important;
  color: #ffbe76 !important;
}

::v-deep .v-date-picker-header .v-btn {
  color: #e0e0e0 !important;
}

::v-deep .v-date-picker-header .v-btn:hover {
  background: rgba(255, 159, 67, 0.2) !important;
}

::v-deep .v-date-picker-table tbody .v-btn {
  color: #e0e0e0 !important;
}

::v-deep .v-date-picker-table tbody .v-btn:hover {
  background: rgba(255, 159, 67, 0.2) !important;
}

/* Tabla */
::v-deep .v-data-table {
  background: transparent !important;
  color: #e0e0e0 !important;
}

::v-deep .v-data-table-header {
  background: linear-gradient(180deg, rgba(255, 159, 67, 0.15) 0%, rgba(255, 159, 67, 0.08) 100%) !important;
}

::v-deep .v-data-table-header th {
  color: #e0e0e0 !important;
  font-weight: 700 !important;
  text-transform: uppercase;
  font-size: 0.75rem;
  letter-spacing: 1px;
  border-bottom: 2px solid rgba(255, 159, 67, 0.3) !important;
  padding: 16px !important;
}

::v-deep .v-data-table tbody tr {
  transition: all 0.3s ease;
  cursor: pointer;
}

::v-deep .v-data-table tbody tr:hover {
  background: rgba(255, 159, 67, 0.1) !important;
  transform: scale(1.005);
  box-shadow: 0 2px 8px rgba(255, 159, 67, 0.2);
}

::v-deep .v-data-table tbody td {
  color: #e0e0e0 !important;
  border-bottom: 1px solid rgba(255, 159, 67, 0.08) !important;
  padding: 16px !important;
}

/* Botones */
::v-deep .v-btn {
  border-radius: 12px !important;
  text-transform: none !important;
  font-weight: 600 !important;
  transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275) !important;
  position: relative;
  overflow: hidden;
}

::v-deep .v-btn::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 0;
  height: 0;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.2);
  transform: translate(-50%, -50%);
  transition: width 0.6s, height 0.6s;
  pointer-events: none;
}

::v-deep .v-btn:active::before {
  width: 300px;
  height: 300px;
}

::v-deep .v-btn:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(255, 159, 67, 0.6) !important;
}

::v-deep .v-btn.secondary {
  background: linear-gradient(135deg, #ff9f43 0%, #ffbe76 100%) !important;
  color: #ffffff !important;
  box-shadow: 0 4px 16px rgba(255, 159, 67, 0.4) !important;
}

::v-deep .v-btn:disabled {
  opacity: 0.5 !important;
  transform: none !important;
  box-shadow: none !important;
}

/* Card actions */
::v-deep .v-card-actions {
  padding: 24px !important;
  background: rgba(255, 159, 67, 0.05);
  border-top: 1px solid rgba(255, 159, 67, 0.1);
}

/* Scrollbar */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: rgba(10, 10, 10, 0.5);
  border-radius: 4px;
}

::-webkit-scrollbar-thumb {
  background: rgba(255, 159, 67, 0.4);
  border-radius: 4px;
  transition: background 0.3s;
}

::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 159, 67, 0.6);
}

/* Animación */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
